import React, { useMemo } from 'react';

import { useGetTopReportedStreamsQuery } from '../../redux/apis/analyticsManagement/aMIptvAnalyticsApiSlice';
import BarChart from '../other/charts/BarChart';
import ComponentLoader from '../other/ComponentLoader';
import { pickTopCounts } from './iptvReportedBarHelpers';

const TOP_DOMAINS_LIMIT = 10;
const CHART_HEIGHT = '380px';

const IPTVTopReportedDomains = ({ chartThemeKey = 0 }) => {
  const { data: reportedStreamsData, isLoading, isError, error } = useGetTopReportedStreamsQuery();

  const domainsBarData = useMemo(
    () => Object.fromEntries(pickTopCounts(reportedStreamsData, TOP_DOMAINS_LIMIT)),
    [reportedStreamsData]
  );

  const hasDomainRows = Object.keys(domainsBarData).length > 0;
  const errorMessage = error?.data?.message;

  return (
    <div className='relative'>
      {isLoading ? <ComponentLoader /> : null}
      {isError ? (
        <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75 z-1'>
          Failed to load.
          {errorMessage ? ` ${errorMessage}` : ''}
        </div>
      ) : null}

      <p className='text-center font-medium mb-2'>Top 10 Reported Domains</p>
      {!isLoading && !isError && !hasDomainRows ? (
        <p className='text-center small text-inverse text-opacity-50'>No domain data.</p>
      ) : !isLoading && !isError ? (
        <BarChart key={`domains-${chartThemeKey}`} data={domainsBarData} height={CHART_HEIGHT} />
      ) : null}
    </div>
  );
};

export default IPTVTopReportedDomains;
